module.exports = __webpack_public_path__ + "static/media/ic_repair_apply.10b87db1.png";